import React from "react";
import { Link } from "react-router-dom";
import { Section } from "../components/ui-shared";

export default function NotFound() {
  return (
    <Section className="min-h-[70vh] grid place-items-center text-center">
      <div>
        <p className="font-mono text-7xl font-bold text-white">404</p>
        <p className="mt-4 text-slate-400">This page drifted out of orbit.</p>
        <Link to="/" className="btn-primary mt-8">Back to Home</Link>
      </div>
    </Section>
  );
}
